<template>
  <DxPopup
    :visible="visible"
    :show-title="true"
    :show-close-button="true"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :title="$t('works.parcels.sync_history_title', { name: parcelName })"
    :width="1100"
    :height="650"
    @hiding="$emit('close')"
  >
    <DxDataGrid
      :data-source="historyRows"
      key-expr="uuid"
      :show-borders="true"
      :show-row-lines="true"
      :column-auto-width="true"
      :row-alternation-enabled="true"
      :no-data-text="$t('works.parcels.sync_history_empty')"
      height="100%"
    >
      <DxColumn data-field="created_at" :caption="$t('works.parcels.sync_history_date')" data-type="datetime" />
      <DxColumn data-field="event_type" :caption="$t('works.parcels.sync_history_event')" cell-template="syncEventCellTemplate" />
      <template #syncEventCellTemplate="{ data }">
        {{ $te('works.parcels.sync_history_events.' + data.value) ? $t('works.parcels.sync_history_events.' + data.value) : data.value }}
      </template>
      <DxColumn data-field="remote_id" :caption="$t('works.parcels.sync_history_remote_id')" />
      <DxColumn data-field="season_name" :caption="$t('common.season')" />
      <DxColumn data-field="change_count" :caption="$t('works.parcels.sync_history_change_count')" data-type="number" />
      <DxMasterDetail :enabled="true" template="syncLogDetailsTemplate" />
      <template #syncLogDetailsTemplate="{ data }">
        <DxDataGrid
          :data-source="data.data.changes"
          :show-borders="true"
          :show-row-lines="true"
          :column-auto-width="true"
          :row-alternation-enabled="true"
          :no-data-text="$t('works.parcels.sync_history_no_changes')"
        >
          <DxColumn data-field="entity" :caption="$t('works.parcels.sync_history_entity')" cell-template="syncEntityCellTemplate" />
          <template #syncEntityCellTemplate="{ data: entity }">
            {{ $te('works.parcels.sync_history_entities.' + entity.value) ? $t('works.parcels.sync_history_entities.' + entity.value) : entity.value }}
          </template>
          <DxColumn data-field="field" :caption="$t('works.parcels.sync_history_field')" cell-template="syncFieldCellTemplate" />
          <template #syncFieldCellTemplate="{ data: field }">
            {{ $te('works.parcels.sync_history_fields.' + field.value) ? $t('works.parcels.sync_history_fields.' + field.value) : field.value }}
          </template>
          <DxColumn data-field="before" :width="280" :caption="$t('works.parcels.sync_history_before')" cell-template="syncValueCellTemplate" />
          <template #syncValueCellTemplate="{ data }">
            <span class="sync-history-value" :title="formatValue(data.value)">{{ displayValue(data.value) }}</span>
          </template>
          <DxColumn data-field="after" :width="280" :caption="$t('works.parcels.sync_history_after')" cell-template="syncValueCellTemplate" />
        </DxDataGrid>
      </template>
    </DxDataGrid>
    <div v-if="loading" class="parcel-sync-history-loading">
      {{ $t('common.loading') }}
    </div>
  </DxPopup>
</template>

<script>
import DxPopup from "devextreme-vue/popup";
import { DxColumn, DxDataGrid, DxMasterDetail } from "devextreme-vue/data-grid";

export default {
  name: "ParcelSyncHistoryPopup",
  components: { DxPopup, DxDataGrid, DxColumn, DxMasterDetail },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    parcelName: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    logs: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    historyRows() {
      return this.logs.map((log) => {
        const changes = Array.isArray(log.changes) ? log.changes : [];
        return {
          ...log,
          season_name: log.season_name || "",
          changes,
          change_count: changes.length,
        };
      });
    },
  },
  methods: {
    displayValue(value) {
      const formatted = this.formatValue(value);
      return formatted.length > 120 ? `${formatted.slice(0, 117)}...` : formatted;
    },
    formatValue(value) {
      if (value === null || value === undefined || value === "") return "-";
      return typeof value === "object" ? JSON.stringify(value) : String(value);
    },
  },
};
</script>

<style scoped>
.sync-history-value {
  display: block;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.parcel-sync-history-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
</style>